import Color from 'color';
import colorDiff from 'color-diff';
import colorString from 'color-string';

export function tryParseColor(maybeColorString: string): Color | undefined {
  // Use `color-string` because checking its result is much faster than catching errors thrown by `color`.
  const result = colorString.get(maybeColorString);
  if (!result) {
    return undefined;
  }

  const { model, value } = result;
  return Color(value, model);
}

export function isEqualColors(colorA: string, colorB: string): boolean {
  if (colorA === colorB) {
    return true;
  }

  try {
    return Color(colorA).hex() === Color(colorB).hex();
  } catch {
    return false;
  }
}

/**
 * Calculates the CIEDE2000 distance between the given colors.
 *
 * @returns number
 *   A distance between 0 and 100 inclusive.
 */
export function compareColors(colorA: Color, colorB: Color): number {
  return colorDiff.diff(colorToLabColor(colorA), colorToLabColor(colorB));
}

function colorToLabColor(color: Color): colorDiff.LabColor {
  return colorDiff.rgb_to_lab({
    R: color.red(),
    G: color.green(),
    B: color.blue(),
  });
}
